import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/immoplus/bc-front-immoplus/src/node_modules/@mui/material/Box/Box.js");
